// src/components/sections/LocationSection/LocationSection.jsx

import React from 'react';
import './LocationSection.css';

const LocationSection = () => {

  const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4423.018165067345!2d-45.060119423924924!3d-22.11543741007068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cb4beae31427e7%3A0xf1cbab8e895df8f5!2sAlzira%20Plaza%20Hotel!5e1!3m2!1spt-BR!2sbr!4v1758218398556!5m2!1spt-BR!2sbr";

  return (
    <section id="localizacao" className="location-section">
      <div className="map-container">
        <iframe
          title="Localização do Hotel Alzira Plaza"
          src={mapUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default LocationSection;
